var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Tambah Role")]), _c('div', {
    staticClass: "flex justify-between items-end gap-12"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('div', {
    staticClass: "mb-6 max-w-sm"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": true
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  })], 1), _c('div', {}, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Role",
      "placeholder": "Nama Role"
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1)]), _c('div', {
    staticClass: "w-1/2"
  }, [_c('Textarea', {
    attrs: {
      "label": "Role Deskripsi",
      "placeholder": "Deskripsi"
    },
    model: {
      value: _vm.payloads.description,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "description", $$v);
      },
      expression: "payloads.description"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex items-stretch shadow-border-b"
  }, [_c('div', {
    staticClass: "w-4/12 p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Permission Group")]), _c('ul', _vm._l(_vm.permissionByGroup, function (item, group) {
    return _c('li', {
      key: 'item-' + group,
      staticClass: "mb-3"
    }, [group === 'Allowed to Manage all' ? _c('span', {
      staticClass: "inline-block cursor-pointer font-medium hover:text-primary-600",
      class: {
        'text-primary-600': _vm.selectedMenu === group
      },
      on: {
        "click": function ($event) {
          return _vm.select('all');
        }
      }
    }, [_vm._v("All")]) : _c('span', {
      staticClass: "inline-block cursor-pointer font-medium hover:text-primary-600",
      class: {
        'text-primary-600': _vm.selectedMenu === group
      },
      on: {
        "click": function ($event) {
          return _vm.select(group);
        }
      }
    }, [_vm._v(_vm._s(group))])]);
  }), 0)]), _c('div', {
    staticClass: "w-8/12 p-6 shadow-border-l"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Capability")]), _c('masonry', {
    attrs: {
      "cols": 2,
      "gutter": 30
    }
  }, _vm._l(_vm.filteredData, function (permission, group) {
    return _c('div', {
      key: permission.id,
      staticClass: "py-2 block"
    }, [_c('p', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(group))]), _vm._l(permission, function (item, index) {
      return _c('div', {
        key: 'item' + index,
        staticClass: "flex gap-6 justify-between items-center py-2"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.payloads.permissions,
          expression: "payloads.permissions"
        }],
        staticClass: "styled-checkbox",
        attrs: {
          "type": "checkbox",
          "name": "goodsCategory",
          "id": item.id
        },
        domProps: {
          "value": item.id,
          "checked": Array.isArray(_vm.payloads.permissions) ? _vm._i(_vm.payloads.permissions, item.id) > -1 : _vm.payloads.permissions
        },
        on: {
          "change": function ($event) {
            var $$a = _vm.payloads.permissions,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;

            if (Array.isArray($$a)) {
              var $$v = item.id,
                  $$i = _vm._i($$a, $$v);

              if ($$el.checked) {
                $$i < 0 && _vm.$set(_vm.payloads, "permissions", $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(_vm.payloads, "permissions", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(_vm.payloads, "permissions", $$c);
            }
          }
        }
      }), _c('label', {
        staticClass: "text-sm",
        attrs: {
          "for": item.id
        }
      }, [_vm._v(_vm._s(item.id))])]);
    })], 2);
  }), 0)], 1)]), _c('div', {
    staticClass: "flex justify-between items-center p-6"
  }, [_c('div', {
    staticClass: "flex gap-6 items-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Pilih Semua",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.selectAll();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Reset Semua",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.resetAll();
      }
    }
  })], 1), _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }